import type {RefObject} from 'react';
import type {IconProps} from '@Components/icon-v2';
import type {TooltipPlacement} from '@Components/icon-with-tooltip/icon-with-tooltip.types';
import type {AiChatCopyImageSource} from '@Libraries/ga-events';
import {CopyAiChatImageStatus} from '@Components/ai-chat-window/hooks/useCopyAiChatImage.types';

export type CopyAiChatImageTooltipPlacement = TooltipPlacement.TOP | TooltipPlacement.BOTTOM;

export const LABEL_KEY_BY_COPY_STATUS: Record<CopyAiChatImageStatus, string> = {
  [CopyAiChatImageStatus.IDLE]: 'pmwjs_copy_image',
  [CopyAiChatImageStatus.COPYING]: 'pmwjs_copy_image_copying',
  [CopyAiChatImageStatus.COPIED]: 'pmwjs_copied',
  [CopyAiChatImageStatus.FAILED]: 'pmwjs_copy_image_not_copied',
};

export const ICON_BY_COPY_STATUS: Record<CopyAiChatImageStatus, string> = {
  [CopyAiChatImageStatus.IDLE]: 'icon-copy',
  [CopyAiChatImageStatus.COPYING]: 'icon-copy',
  [CopyAiChatImageStatus.COPIED]: 'icon-check',
  [CopyAiChatImageStatus.FAILED]: 'icon-exclamation-circle',
};

export type CopyAiChatImageIconProps = Pick<IconProps, 'type' | 'shape' | 'className' | 'size' | 'loaderClassName'>;

export interface CopyAiChatImageButtonProps {
  hashedId: string;
  source: AiChatCopyImageSource;
  iconProps: CopyAiChatImageIconProps;
  tooltipPlacement?: CopyAiChatImageTooltipPlacement;
  tooltipContainer?: RefObject<HTMLElement | null>;
}
